export const searchFeatures = {
  byCode: 'Search by Code',
  byCategory: 'Search by Category',
  byDescription: 'Search by Description',
};
